import {
  faBuilding,
  faBullhorn,
  faDesktop,
  faFileChartPie,
  faGear,
  faHome,
  faListCheck,
  faShieldCheck,
  faShieldExclamation,
  faTriangleExclamation
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LogscaleSvgIcon from '@/components/LogscaleSvgIcon';
import PonduranceSvgIcon from '@/components/PonduranceSvgIcon';
import { LOGSCALE_URL } from '@/constants/common';
import { PRODUCTS } from '@/constants/products.constants';
import { convertLogscaleLinks } from '@/utils/Common.utils';

import { PERMISSIONS } from './auth.constants';

const SIDEBAR_WIDTH_COLLAPSED = '4rem';
const SIDEBAR_WIDTH_EXPANDED = '18.5rem';

const SIDEBAR_MENU_ITEMS = [
  {
    ariaLabel: 'navigate to dashboard page',
    component: <FontAwesomeIcon icon={faHome} />,
    label: 'Dashboard',
    pathTo: '/dashboard',
    permissions: PERMISSIONS.TICKETS_READ
  },
  {
    ariaLabel: 'navigate to tickets page',
    component: <FontAwesomeIcon icon={faListCheck} />,
    label: 'Tickets',
    pathTo: '/tickets',
    permissions: PERMISSIONS.TICKETS_READ
  },
  {
    ariaLabel: 'navigate to cases page',
    component: <FontAwesomeIcon icon={faTriangleExclamation} />,
    label: 'Cases',
    pathTo: '/cases',
    permissions: [PERMISSIONS.CASES_READ]
  },
  {
    ariaLabel: 'navigate to asset inventory page',
    component: <FontAwesomeIcon icon={faDesktop} />,
    label: 'Asset Inventory',
    pathTo: '/asset-inventory',
    permissions: PERMISSIONS.ASSET_READ
  },
  {
    ariaLabel: 'navigate to vulnerability management page',
    component: <FontAwesomeIcon icon={faShieldExclamation} />,
    label: 'Vulnerability Management',
    pathTo: '/vulnerability-management/vulnerabilities',
    requiredProducts: [PRODUCTS.VMPE],
    permissions: PERMISSIONS.VMP_READ
  },
  {
    ariaLabel: 'navigate to reports page',
    component: <FontAwesomeIcon icon={faFileChartPie} />,
    label: 'Reports',
    pathTo: '/reports',
    permissions: PERMISSIONS.REPORT_READ
  },
  {
    ariaLabel: 'navigate to announcements page',
    component: <FontAwesomeIcon icon={faBullhorn} />,
    label: 'Announcements',
    pathTo: '/announcements',
    permissions: PERMISSIONS.ANNOUNCEMENT_READ
  },
  {
    ariaLabel: 'navigate to administration page',
    component: <FontAwesomeIcon icon={faGear} />,
    label: 'Administration',
    pathTo: '/administration',
    permissions: PERMISSIONS.ADMIN_READ
  },
  {
    ariaLabel: 'navigate to my cyber score card',
    component: <FontAwesomeIcon icon={faShieldCheck} />,
    label: 'MyCyberScorecard',
    link: 'https://pondurance.outsystemsenterprise.com/MyCyberScorecard',
    permissions: PERMISSIONS.TICKETS_READ,
    requiredProducts: [PRODUCTS.MCSC]
  },
  {
    ariaLabel: 'navigate to logscale',
    component: <LogscaleSvgIcon fillcolor="#646568" sizeHeightWidth={25} />,
    label: 'Logscale',
    link: convertLogscaleLinks(LOGSCALE_URL),
    permissions: PERMISSIONS.LOGS_READ,
    requiredProducts: null,
    mobileOnly: true
  },
  {
    ariaLabel: 'display internal menu',
    component: <PonduranceSvgIcon outline height="1.5rem" />,
    label: 'Internal',
    menu: [
      {
        ariaLabel: 'navigate to internal cases page',
        label: 'Cases (Internal)',
        pathTo: '/cases-internal',
        permissions: [PERMISSIONS.CASES_READ, PERMISSIONS.INTERNAL]
      },
      {
        ariaLabel: 'navigate to main alert rules page',
        label: 'Alert Rules',
        pathTo: '/alert-rules',
        permissions: [PERMISSIONS.CASES_READ, PERMISSIONS.INTERNAL]
      },
      {
        ariaLabel: 'navigate to main devices page',
        label: 'Devices',
        pathTo: '/devices',
        permissions: [PERMISSIONS.DEVICES_READ]
      },
      {
        ariaLabel: 'navigate to organizations page',
        component: <FontAwesomeIcon icon={faBuilding} />,
        label: 'Organizations',
        pathTo: '/organizations',
        permissions: [PERMISSIONS.ORGANIZATIONS_READ, PERMISSIONS.INTERNAL]
      }
    ],
    permissions: [PERMISSIONS.INTERNAL]
  }
];

export { SIDEBAR_MENU_ITEMS, SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED };
